import { ITarget } from "./ITarget";

export const EmptyTarget: ITarget = {
    reporting_Period: null,
    sub: null,
    req: null,
    ecs: null,
    eci: null,
    po: null,
}